export default __webpack_public_path__ + "static/media/icone_page_404.9a666038.svg";